/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { APIProvider, Map, Marker, InfoWindow, AdvancedMarker, Pin, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import zackatPin from '../data/mappin.png';
import googleMap from '../data/google-maps.png';
import './Map.css';

export default function AMap({ dt }) {
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [refreshData, setRefreshData] = useState(true);
  const [locateData, setLocations] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [markers, setMarker] = useState([]);
  const { REACT_APP_API_ENDPOINT } = process.env;
  let { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env;
  const { REACT_APP_GOOGLE_MAPS_API_KEY_DEV } = process.env;
  const { REACT_APP_ENV } = process.env;
  const { REACT_APP_GOOGLE_MAPS_ID } = process.env;
  if (!REACT_APP_ENV || REACT_APP_ENV === '') {
    REACT_APP_GOOGLE_MAPS_API_KEY = REACT_APP_GOOGLE_MAPS_API_KEY_DEV;
  }
  const [markerRef, amarker] = useAdvancedMarkerRef();
  const { amapActive, setAmapActive } = useStateContext();
  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker) => {
    setInfoWindowShown((isShown) => !isShown);
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const timerid = useRef();
  let map;
  const usr = JSON.parse(localStorage.getItem('user'));
  const selectedOrg = JSON.parse(localStorage.getItem('organization'));
  if (selectedOrg && usr) {
    usr.organizationid = selectedOrg.id;
  }
  const [defcenter, setDefaultCenter] = useState({});
  let initialMarkers = [];

  async function getData() {
    const loc = window.location;
    // if (loc.pathname !== '/associates' && loc.pathname !== '/associate') {
    //  timerid.current = clearInterval(timerid.current);
    // }
    usr.limit = '1000';
    const query = Object.entries(usr)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
    if (timerid.current) {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/associates?${query}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          setData(response.data);
          initialMarkers = [];
          if (response.data && response.data.associates) {
            response.data.associates.map((event) => {
              // const exists = checkMarker(event);
              if (event && event.latlng && event.latlng.latitude !== 0 && event.latlng.longitude !== 0) {
                const marker = {
                  lat: event.latlng.latitude,
                  lng: event.latlng.longitude,
                  title: event.name,
                  device: event.device,
                  _id: event._id,
                  info: `Title: ${event.jobtask}`,
                  image: event.employeeImage,
                };
                initialMarkers.push(marker);
              }
            });
            // timerid.current = setInterval(getData, 30000);
            if (timerid.current && !amapActive) {
              clearInterval(timerid.current);
              timerid.current = null;
            }
            if (initialMarkers.length > 0) {
              setMarker(initialMarkers);
              const center = { lat: Number(initialMarkers[0].lat), lng: Number(initialMarkers[0].lng) };
              setDefaultCenter(center);
              setLoadingData(false);
            }
          }
        })
        .catch((error) => console.error(error));
    }
  }

  useEffect(() => {
    if (timerid.current && !amapActive) {
      clearInterval(timerid.current);
      timerid.current = null;
    } else if (!timerid.current && amapActive) {
      timerid.current = setInterval(getData, 30000);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, [amapActive]);
  // This will run one time after the component mounts
  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      timerid.current = setInterval(getData, 30000);
      setTimeout(getData, 500);
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      timerid.current = clearInterval(timerid.current);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  function clearMarkers(markers) {
    markers = [];
  }
  function checkMarker(val) {
    return markers.some((item) => val._id === item._id);
  }
  if (loadingData && !refreshData) {
    return <p>Loading... </p>;
  }
  const [infoWindowShown, setInfoWindowShown] = useState(false);

  // if the maps api closes the infowindow, we have to synchronize our state
  const handleClose = useCallback(() => setInfoWindowShown(false), []);
  const currentThemeColor = localStorage.getItem('colorMode');

  return (
    <div style={{
      backgroundColor: currentThemeColor,
      textAlign: 'right',
      marginTop: '-40px',
    }}
    >
      <button
        className="button"
        type="button"
        style={{
          borderWidth: 1,
          borderColor: 'rgba(0,0,0,0.2)',
          alignItems: 'center',
          justifyContent: 'center',
          width: 30,
          height: 30,
          borderRadius: 100,
        }}
        onClick={() => { setLocations(!locateData); setAmapActive(!amapActive); }}
      >
        <img src={googleMap} alt="map" />
      </button>
      <APIProvider
        apiKey={`${REACT_APP_GOOGLE_MAPS_API_KEY}`}
      >
        {locateData && !loadingData && (
          <Map
            style={{ width: '100%', height: '100vh' }}
            defaultCenter={defcenter}
            mapId={`${REACT_APP_GOOGLE_MAPS_ID}`}
            defaultZoom={10}
            onClick={() => setActiveMarker(null)}
          >
            {markers.map((marker) => (
              <AdvancedMarker
                className="bounce"
                key={marker._id}
                onClick={() => handleActiveMarker(marker)}
                position={marker}
                ref={markerRef}
              >
                <img src={zackatPin} width="60px" height="60px" />
                {infoWindowShown && activeMarker && activeMarker.device && (
                  <InfoWindow
                    position={activeMarker}
                    onClose={() => handleClose()}
                  >
                    <h2>Device: {activeMarker.device}</h2>
                    <p>{activeMarker.info}</p>
                    <div>
                      <h1>{activeMarker.title}</h1>
                    </div>

                  </InfoWindow>
                )}
              </AdvancedMarker>
            ))}
          </Map>
        )}
      </APIProvider>
    </div>
  );
}
